import { SELECTED_ROLE_LOCAL_STORAGE_KEY, GA_EVENT_OBJECT, UserRole } from '@/constants';

type GAEventObject = {
  user_role: string;
  user_company: string;
};

function getSelectedRoleStorage(userId: unknown): UserRole | null {
  return localStorage.getItem(`${SELECTED_ROLE_LOCAL_STORAGE_KEY}_${userId}`) as UserRole;
}

function setSelectedRoleStorage(userId: unknown, role: string) {
  localStorage.setItem(`${SELECTED_ROLE_LOCAL_STORAGE_KEY}_${userId}`, role);
}

function removeSelectedRoleStorage(userId: unknown) {
  localStorage.removeItem(`${SELECTED_ROLE_LOCAL_STORAGE_KEY}_${userId}`);
}

function getGAEventObjectStorage(userId: unknown) {
  const jsonStr = localStorage.getItem(`${GA_EVENT_OBJECT}_${userId}`);

  try {
    return JSON.parse(jsonStr || '') as GAEventObject;
  } catch {
    return null;
  }
}

function setGAEventObjectStorage(userId: unknown, obj: GAEventObject) {
  localStorage.setItem(`${GA_EVENT_OBJECT}_${userId}`, JSON.stringify(obj));
}

function removeGAEventObjectStorage(userId: unknown) {
  localStorage.removeItem(`${GA_EVENT_OBJECT}_${userId}`);
}

export {
  getSelectedRoleStorage,
  setSelectedRoleStorage,
  removeSelectedRoleStorage,
  getGAEventObjectStorage,
  setGAEventObjectStorage,
  removeGAEventObjectStorage,
};
